<template>
  <div class="qb-filters">
    <div class="accordion-wrapper">
      <div class="accordion-title flex justify-between">
        {{$tc('filter.label', 2)}}

        <span>
          <span
              :class="{ 'active': articleLevel }"
              class="fas fa-layer-group mr20"
              v-tooltip="articleLevel ? $t('filter.filterAtArticleLevel') : $t('filter.filterAtArticleLevelNot')" 
              @click="toggleArticleLevel"
          ></span>
          <span
            :class="{ 'active': showAdvanced}"
            class="fas fa-eye mr20"
            v-tooltip="showAdvanced ? $t('filter.toggle_tag_view') : $t('filter.toggle_query_view')"
            @click="toggleAdvanced"
          ></span>
          <span
            :class="`fas fa-eraser`"
            v-tooltip="$t('form.button.clear')"
            @click="clearFilters"
          ></span>
        </span>
      </div>
      <div class="accordion-content">
        <div v-if="showAdvanced" id="advanced-filters" class="advanced">
          <template v-for="(mention, i) in filtersList">
            <app-tag v-if="mention.type === QUERIES.FILTER_TYPE.TAG || mention.type === QUERIES.FILTER_TYPE.BREAKDOWN" :key="mention+i"
              parentContainerId="qb-filters"
              :tag="mention"
              display="text"
            />
            <app-tag-group v-if="mention.type === QUERIES.FILTER_TYPE.GROUP" :key="mention+i"
              :parentContainerId="'qb-filters-'+i"
              :group="mention"
              display="text"
            />
            <span v-if="i < filters.length - 1" :key="mention+i+'and'" class="joiner and">
              {{$t('advanced.and')}}
            </span>
          </template>
        </div>

        <div v-else id="filters" :class="{ 'filter-drop-off': true, 'dragging': dragging }" @dragover.prevent @drop.prevent="onDropFilters">
          <template v-for="(mention, i) in filtersList">
            <app-tag v-if="mention.type === QUERIES.FILTER_TYPE.TAG || mention.type === QUERIES.FILTER_TYPE.BREAKDOWN" :key="mention+i"
              parentContainerId="qb-filters"
                            :tag="mention"
                            @deleteMentionTag="deleteMentionTag"
                            @negateMentionTag="(tag) => negateMention({ tag })"
                            @dragover.native.prevent
                            @drop.native.prevent="(e) => joinFilters(e, { tag: mention })"
            />
            <app-tag-group v-if="mention.type === QUERIES.FILTER_TYPE.GROUP" :key="mention+i"
              :parentContainerId="'qb-filters-'+i"
              :group="mention"
              @deleteMentionTag="deleteMentionTag"
              @negateMentionGroup="() => negateMention({ group: mention })"
              @dragover.native.prevent
              @drop.native.prevent="(e) => joinFilters(e, { group: mention })"
              @spreadMentionGroup="spreadMentionGroup"
            />
            <i
              v-if="mention.isLast && tagFilters.length > 1"
              :key="`changeFilter${i}`"
              role="button"
              class="fas expand fa-ellipsis-h group-filters"
              v-tooltip="$t('filter.group_tag_filters')"
              @click.prevent="joinTagFilters(i)"
            ></i>
          </template>
          
          <div v-if="dragging && filters.length === 0" class="placeholder">{{$t('drop_here')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';
  import { QUERIES } from '../../config/const';
  import Tag from './tag';
  import TagGroup from './tag_group';

  function getUID() {
    return `_${Math.random().toString(36).substr(2, 9)}`;
  }

  export default {
    props: {
      filters: {
        type: Array,
        default: () => []
      },
      querySettings:{
        type: Object,
        default:()=> {}
      },
      onDrop: {
        type: Function,
        default: () => null
      },
      dragging: {
        type: Boolean,
        default: () => false
      }
    },
    components: {
      'app-tag': Tag,
      'app-tag-group': TagGroup
    },
    data: function() {
      return {
        QUERIES,
        showAdvanced: false,
        articleLevel: false,
      } 
    },
    computed: {
      tagFilters() {
        return this.filters
          .filter(
            filter => {
              return filter.type === QUERIES.FILTER_TYPE.TAG ||
              filter.type === QUERIES.FILTER_TYPE.BREAKDOWN
          });
      },
      filtersList() {
        if (!this.filters || (this.filters && !this.filters.length)) return [];

        const allFilters = _.cloneDeep(this.filters);
        let previousLastTag;

        allFilters.forEach((filter, i) => {
          if (
            filter.type === QUERIES.FILTER_TYPE.TAG ||
            filter.type === QUERIES.FILTER_TYPE.BREAKDOWN
          ) {
            const nextItem = i + 1 <= this.filters.length
              ? this.filters[i + 1]
              : null;

            filter.isLast = false;

            if (!nextItem || nextItem.type === QUERIES.FILTER_TYPE.GROUP) {
              if (previousLastTag && previousLastTag.isLast)
                previousLastTag.isLast = false;

              filter.isLast = true;
              previousLastTag = _.cloneDeep(filter);
            }
          }
        });

        return allFilters;
      },
    },
    methods: {
      onDropFilters (e) {
        if(!this.dragging) return;

        const data = e.dataTransfer.getData('filters');
  
        if (data) {
          const tags = JSON.parse(data).filter(dt => dt.type === QUERIES.FILTER_TYPE.TAG || dt.type === QUERIES.FILTER_TYPE.BREAKDOWN).map(t => ({ ...t, negative: false }));
          const filters = _.uniqWith([ ...this.filters, ...tags ], this.tagIsEqual);
          this.$emit('setQueryEntity', { entity: 'filters', value: filters })
        }
        this.onDrop(data);
      },
      deleteMentionTag (tag) {
        let { filters } = this;
        if (tag.groupUid) {
          filters = filters.map(f => {
            if (f.type === QUERIES.FILTER_TYPE.GROUP && f.uid === tag.groupUid) {
              
              let data = {
                ...f,
                tags: f.tags.filter(t => t.uid !== tag.uid)
                // tags: _.uniqWith(f.tags.filter(t => t.uid !== tag.uid), this.tagIsEqual)
              }

              if (data.tags.length <= 1) {
                let tag = data.tags[0];
                delete tag.groupUid;
                data = tag;
              }

              return data;
            }
            
            return f;
          })
        }
        else {
          filters = filters.filter(f => f.uid !== tag.uid);
          // filters = _.uniqWith(filters, this.tagIsEqual);
        }

        this.$emit('setQueryEntity', { entity: 'filters', value: _.uniqWith(filters, this.tagIsEqual) })
      },
      clearFilters() {
        this.showAdvanced = false;
        this.$emit('setQueryEntity', { entity: 'filters', value: [] })
      },
      negateMention ({ tag, group }) {
        let filters;
        if (tag) {
          filters = this.filters.map(t => {
            return t.type === QUERIES.FILTER_TYPE.GROUP || t.uid !== tag.uid ? t : { ...t, negative: !t.negative }
          })
        }
        else if (group) {
          filters = this.filters.map(t => {
            if (t.type === QUERIES.FILTER_TYPE.GROUP && t.uid === group.uid) {
              return {
                ...t,
                negative: !t.negative
              }
            }
            else {
              return t;
            }
          })
        }

        this.$emit('setQueryEntity', { entity: 'filters', value: filters })
      },
      joinTagFilters(selectedIndex) {
        if (this.tagFilters.length < 2) return;

        let itemsToJoin = this.filtersList.slice(0, selectedIndex + 1);

        itemsToJoin = itemsToJoin.reverse();

        let lastItemInReversed;

        itemsToJoin.some((item, i) => {
          if (item.type === QUERIES.FILTER_TYPE.GROUP) return item;
          lastItemInReversed = i;
        });

        itemsToJoin = itemsToJoin.slice(0, lastItemInReversed + 1);
        itemsToJoin = itemsToJoin.reverse();

        const totalToJoin = itemsToJoin.length;
        const allItems = _.cloneDeep(this.filtersList);
        const startIndex = selectedIndex + 1 - totalToJoin;
        const uid = getUID();

        itemsToJoin.forEach((tag) => {
          tag.groupUid = uid;
          tag.negative = false;
        });

        const newGroup = {
          type: QUERIES.FILTER_TYPE.GROUP,
          negative: false,
          groupUid: uid,
          uid: uid,
          tags: itemsToJoin,
        };

        allItems[startIndex] = newGroup;
        allItems.splice(startIndex + 1, totalToJoin - 1);

        this.$emit("setQueryEntity", { entity: "filters", value: allItems });
      },
      joinFilters (e, { tag, group }) {
        if(!this.dragging) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        
        const data = e.dataTransfer.getData('filters');
        if (data) {
          const droppedTags = JSON.parse(data);
 
          let { filters } = this;
          const index = filters.findIndex(filter => (tag && ((tag.type === QUERIES.FILTER_TYPE.TAG && tag.tag_id === filter.tag_id) || (tag.type === QUERIES.FILTER_TYPE.BREAKDOWN && tag.id === filter.id))) || (group && filter.uid === group.uid));

          let joiningTags = [];
          if (tag) {
            joiningTags = droppedTags.filter(t => !((t.type === QUERIES.FILTER_TYPE.TAG && t.tag_id === tag.tag_id && t.category_id === tag.category_id) || (t.type === QUERIES.FILTER_TYPE.BREAKDOWN && t.id === tag.id && t.breakdown_id === tag.breakdown_id)));
          }
          else if (group) {
            joiningTags = droppedTags.filter(t => group.tags.filter(gt => (gt.type === QUERIES.FILTER_TYPE.TAG && gt.tag_id === t.tag_id && gt.category_id === t.category_id) || (gt.type === QUERIES.FILTER_TYPE.BREAKDOWN && gt.id === t.id && gt.breakdown_id === t.breakdown_id)).length === 0);
          }

          if (joiningTags.length > 0) {
            filters = filters.map((filter, i) => {
              if (i === index) {
                let group;
                if (filter.type === QUERIES.FILTER_TYPE.TAG || filter.type === QUERIES.FILTER_TYPE.BREAKDOWN) {
                  group = {
                    type: QUERIES.FILTER_TYPE.GROUP,
                    negative: false,
                    tags: _.uniqWith([
                      filter, 
                      ...droppedTags
                    ], this.tagIsEqual)
                  }
                }
                else {
                  group = {
                    ...filter,
                    tags: [ ...filter.tags, ...droppedTags.map(t => ({
                      ...t,
                      negative: false,
                      groupUid: filter.uid
                    })) ]
                  }
                }

                return group;
              }
              else {
                return filter;
              }
            });
          }

          const value = JSON.parse(JSON.stringify(filters)) // deep cloning filters
            .map(f => {
              (f.tags || []).map(t => {
                t.negative = false;
                return t;
              });
              return f;
            }) // make all tags positive when creating group

          this.$emit('setQueryEntity', { entity: 'filters', value })
        }
      },
      spreadMentionGroup (group) {
        const { filters } = this;
        let filterValues = [];
        filters.forEach(f => {
          if (f.type === QUERIES.FILTER_TYPE.GROUP && f.uid === group.uid) {
            const tags = f.tags.map(t => {
              let tag = t;
              delete t.groupUid;
              return tag;
            });
            filterValues = _.concat(filterValues, tags);
          }
          else {
            filterValues.push(f);
          }
        })

        this.$emit('setQueryEntity', { entity: 'filters', value: _.uniqWith(filterValues, this.tagIsEqual) })
      },
      toggleAdvanced () {
        this.showAdvanced = !this.showAdvanced;
      },
      toggleArticleLevel() { 
        this.articleLevel = !this.articleLevel;
        this.$emit('setQueryEntity', { entity: 'query_settings', value:  { filter_at_article_level: this.articleLevel } });
      },
      tagIsEqual(a, b) {
        return (a.type === QUERIES.FILTER_TYPE.TAG && a.tag_id === b.tag_id && a.category_id === b.category_id) ||
          (a.type === QUERIES.FILTER_TYPE.BREAKDOWN && a.id === b.id && a.breakdown_id === b.breakdown_id);
      }
    },
    watch: {
      'querySettings.filter_at_article_level': {
        handler(value) {
          this.articleLevel = value;
        }
      },
      'filters': {
        handler(value) {
          if (value.filter(f => typeof f.uid === 'undefined' || (f.type === QUERIES.FILTER_TYPE.GROUP && f.tags.filter(tag => typeof tag.uid === 'undefined').length > 0)).length > 0) {
            const filters = value.map(f => {
              const uid = getUID();
              let filter = { ...f, uid };
              if (f.type === QUERIES.FILTER_TYPE.GROUP) {
                filter.tags = filter.tags.map(t => ({ 
                  ...t,
                  uid: getUID(),
                  groupUid: uid
                }));
              }
              return filter;
            });
            this.$emit('setQueryEntity', { entity: 'filters', value: filters })
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "../../styles/components/coding-queries/filters-panel.scss";
</style>